import { useContext, useState, useEffect } from "react";
import { createComponent, FelaComponent } from "react-fela";
import { gutters, layout, breakpoints } from "~/styleguide";
import { fluid } from "~/styleguide/utils";
import globalData from "~/data/site-data.json";
import { colors } from "~/styleguide";
import { clearAllBodyScrollLocks } from "body-scroll-lock";
import get from "lodash.get";

import Navigation from "./navigation";
import MobileNavigation from "./mobile-navigation";
import WordpressLink from "~/components/global/links";
import { ContentMaxWidth, SiteMaxWidth } from "~/components/layout/max-width";
import TertiaryNav from "./tertiary";
import { DataContext } from "~/context/content";

export default function SiteHeader() {
    // Global Data ACF Fields
    const { acf } = globalData.data;

    const pageData = useContext(DataContext);
    const type = get(pageData, "type");
    const slug = get(pageData, "slug");

    const signInLabel = get(acf, "header_sign_in_label");
    const signInLink = get(acf, "header_sign_in_link");
    const phoneNumber = get(acf, "header_phone_number");

    const [isMobileOpen, setIsMobileOpen] = useState(false);
    const onResize = () => {
        if (window.innerWidth < breakpoints.minWidthDesktop) {
            clearAllBodyScrollLocks();
            setIsMobileOpen(false);
        }
    };

    const CTA = styles => {
        return (
            <>
                {acf.primary_cta_link && acf.primary_cta_label && (
                    <FelaComponent
                        style={styles}
                        onClick={() => {
                            alert("clicked!");
                        }}
                    >

                      {acf.secondary_cta_link && acf.secondary_cta_label && (
                        <WordpressLink
                            url={acf.secondary_cta_link}
                            label={acf.secondary_cta_label}
                            layout="button"
                            outline={true}
                            color={colors.blue}
                            backgroundColor={colors.white}
                            extend={secondaryButtonStyle}
                            onClick={() => {
                                if (!window || !window.ga) return;
                                window.ga(
                                    "send",
                                    "event",
                                    "CTA",
                                    "click",
                                    "Product Tour - Global Header"
                                );
                            }}

                        />
                      )}
                        <WordpressLink
                            url={acf.primary_cta_link}
                            label={acf.primary_cta_label}
                            layout="button"
                            extend={primaryButtonStyle}
                            onClick={() => {
                                if (!window || !window.ga) return;
                                window.ga(
                                    "send",
                                    "event",
                                    "CTA",
                                    "click",
                                    "Demo Request - Global Header"
                                );
                            }}
                        />
                    </FelaComponent>
                )}
            </>
        );
    };

    useEffect(() => {
        if (window && isMobileOpen) {
            window.addEventListener("resize", onResize);
        } else {
            window.removeEventListener("resize", onResize);
        }
    });

    return (
        <>
            {type == "embeddedpage" &&
            <style
                dangerouslySetInnerHTML={{
                    __html: `body {margin-top: 0px;}`
                }}
            />
            }
            {slug !== "construction" && type !== "embeddedpage" &&
            <SiteMaxWidth extend={containerStyles}>
                {/* Phone number and sign in links */}
                <TertiaryNav
                    signInLabel={signInLabel}
                    signInLink={signInLink}
                    phoneNumber={phoneNumber}
                    cta={CTA}
                />

                <ContentMaxWidth extend={{ maxWidth: layout.mainNavWidth }}>
                    <MainHeader>
                        {/* Logo */}
                        <WordpressLink
                            url="/"
                            layout="text"
                            extend={{
                                "& img": {
                                    height: 24
                                },
                                display: "block",
                                position: "relative",
                                zIndex: 5,
                                marginRight: 25,
                                maxWidthTablet: {
                                    marginTop: 8,
                                    "& img": {
                                        height: 18
                                    }
                                }
                            }}
                        >
                            <img
                                src="/brand/logo-revenueio-colored.svg"
                                alt="revenue - Home page"
                            />
                        </WordpressLink>

                        {/* Main navigation */}
                        {type !== "landingpages" && <Navigation className="tablet-nav" />}

                        {/* CTA Button and Hamburger */}

                        {/* Mobile Phone Number */}
                        {phoneNumber && (
                            <FelaComponent
                                as="span"
                                className="ringdna-smartnumber"
                                style={{
                                    fontSize: 12,
                                    marginLeft: "auto",
                                    minWidthTablet: { display: "none" }
                                }}
                            >
                                {phoneNumber}
                            </FelaComponent>
                        )}

                        {type !== "landingpages"  && CTA(ctaStyles)}

                        {type !== "landingpages" && (
                            <Hamburger
                                onClick={() => {
                                    setIsMobileOpen(
                                        isMobileOpen === false ? true : false
                                    );
                                }}
                                isOpen={isMobileOpen}
                            >
                                <Patty />
                                <Patty />
                                <Patty />
                                <Patty />
                            </Hamburger>
                        )}
                    </MainHeader>
                </ContentMaxWidth>
            </SiteMaxWidth>}

            <MobileNavigation
                isOpen={isMobileOpen}
                className="mobile-nav"
                closeNav={() => {
                    setIsMobileOpen(false);
                }}
            >
                {acf.primary_cta_link && acf.primary_cta_label && (
                    <WordpressLink
                        url={acf.primary_cta_link}
                        label={acf.primary_cta_label}
                        layout="button"
                        extend={ctaButtonStyle}
                        className={"desktop-nav mobile-footer-cta"}
                    />
                )}
            </MobileNavigation>
        </>
    );
}

const ctaStyles = {
    display: "none",
    position: "relative",
    zIndex: 5,
    marginLeft: 30,

    minWidthDesktop: {
      display: "inline-block"
    }
};

const containerStyles = {
    position: "fixed",
    width: "100%",
    left: "auto",
    right: "auto",
    top: 0,
    backgroundColor: "#FFFFFF",
    zIndex: 100,
    "& .mobile-nav": {
        display: "none"
    },
    "& .desktop-nav": {
        display: "none"
    },
    "& .tablet-nav": {
        display: "none"
    },

    extend: [fluid("paddingH", gutters.header)],

    maxWidthDesktop: {
        "& .mobile-nav": {
            display: "block"
        }
    },

    minWidthDesktop: {
        "& .tablet-nav": {
            display: "inline-block"
        }
    },
};

const ctaButtonStyle = {
    position: "relative",
    zIndex: 5,
    marginLeft: 30,
    maxWidthTablet: {
        width: "100%",
        textAlign: "center",
        lineHeight: "50px",
        bottom: 0,
        left: 0,
        right: 0,
        marginLeft: 0,
        marginBottom: 35,
        marginTop: 20
    }
};

const MainHeader = createComponent(
    () => ({
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        height: 66,
        minWidthTablet: { top: -4 },
        position: "relative",

        background: "white",
        // extend: [fluid("paddingH", gutters.header)],
        maxWidthTablet: {
            height: 60
        }
    }),
    "header"
);

const Hamburger = createComponent(
    ({ isOpen }) => ({
        width: 20,
        height: 15,
        position: "relative",
        transform: "rotate(0deg)",
        transition: ".5s ease-in-out",
        cursor: "pointer",
        display: "none",
        verticalAlign: "middle",
        marginLeft: 20,
        "& :nth-child(1)": {
            top: 0
        },
        "& :nth-child(2)": {
            top: 6
        },
        "& :nth-child(3)": {
            top: 6
        },
        "& :nth-child(4)": {
            top: 12
        },
        maxWidthDesktop: {
            display: "inline-block"
        },

        extend: [
            {
                condition: isOpen,
                style: {
                    "& :nth-child(1)": {
                        top: 5,
                        width: "0%",
                        left: "50%"
                    },
                    "& :nth-child(2)": {
                        transform: "rotate(45deg)"
                    },
                    "& :nth-child(3)": {
                        transform: "rotate(-45deg)"
                    },
                    "& :nth-child(4)": {
                        top: 5,
                        width: "0%",
                        left: "50%"
                    }
                }
            }
        ]
    }),
    "div",
    ["onClick"]
);

const Patty = createComponent(
    {
        display: "block",
        position: "absolute",
        height: 1,
        width: "100%",
        background: colors.black,
        opacity: 1,
        left: 0,
        transform: "rotate(0deg)",
        transition: ".25s ease-in-out"
    },
    "span"
);
const secondaryButtonStyle = {
        marginRight: "12px",
        borderWidth: "2px !important",
        borderStyle: "solid !important",
        borderColor: "#3B58F5",
        whenActive: {
            backgroundColor: "#f0f0f0 !important",
        },
};

const primaryButtonStyle = {
        borderWidth: "2px !important",
        borderStyle: "solid !important",
        borderColor: "#3B58F5 !important",
};
